import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { EmailCTA } from '@/features/landing/components/EmailCTA';

interface FooterSectionProps {
  cta?: ReactNode;
}

export function FooterSection({ cta }: FooterSectionProps) {
  const { t } = useTranslation();

  return (
    <>
      {/* Footer CTA Section */}
      <section className="relative py-32 px-4 bg-black/10 overflow-hidden">
        {/* Geometric accents */}
        <div className="absolute inset-0">
          <div
            className="absolute -top-16 -left-16 w-[300px] h-[300px] rotate-[15deg] opacity-[0.06]"
            style={{ backgroundColor: 'var(--decoration-primary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
          />
          <div
            className="absolute -bottom-20 -right-20 w-[350px] h-[350px] rotate-[-20deg] opacity-[0.05]"
            style={{ backgroundColor: 'var(--decoration-secondary)', clipPath: 'polygon(25% 0%, 75% 0%, 100% 50%, 75% 100%, 25% 100%, 0% 50%)' }}
          />
        </div>
        <div className="relative z-10 max-w-2xl mx-auto text-center">
          <h2 className="text-3xl mb-6">{t('footer.soundGood')}</h2>
          <p className="text-muted-foreground text-sm mb-8">
            {t('footer.getStarted')}
          </p>
          {cta ?? <EmailCTA location="footer" />}
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-black/15 py-8 px-4">
        <div className="max-w-6xl mx-auto text-center space-y-3">
          <div className="flex items-center justify-center gap-4 text-xs text-muted-foreground/60">
            <Link to="/privacy" className="hover:text-white/80 transition-colors">
              {t('footer.privacyPolicy')}
            </Link>
            <span>&middot;</span>
            <Link to="/terms" className="hover:text-white/80 transition-colors">
              {t('footer.termsOfService')}
            </Link>
            <span>&middot;</span>
            <Link to="/cookies" className="hover:text-white/80 transition-colors">
              {t('footer.cookiePolicy')}
            </Link>
          </div>
          <p className="text-muted-foreground/60 text-xs">
            &copy; {t('footer.copyright')}
          </p>
        </div>
      </footer>
    </>
  );
}
